import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Global } from '../Service/global.service';
import { HomeService } from '../Service/home.service';
import { PublicationsService } from '../Service/publications.service';

declare var $: any
import * as _ from 'lodash';
import { forkJoin } from 'rxjs';
import { StatistiquesService } from '../Service/statistiques.service';

@Component({
  selector: 'app-home2',
  templateUrl: './home2.component.html',
  styleUrls: ['./home2.component.scss']
})
export class Home2Component implements OnInit {
  offres: any[];
  slick1: any;
  isArab=false;
  lastAnnualReport = null;
  currentLg;
  lastMonthReport = null;
  lastSynthese = null;
  regions = [];
  selectedRegion = "";  
  selectedPort = null
  selectedActivite = [];
  selectedPortPath = null;
  filterRegions = [];

  constructor(public global: Global, private StatistiqueService:StatistiquesService, private service: HomeService, private publicationService: PublicationsService, private router: Router) { }
  acceuil1 = {
    title: '',
    content: '',
    variables:''
  }
  acceuil2 = {
    title: '',
    content: ''
  }
  acceuil3 = {
    title: '',
    content: '',
    variables:''
  }
  acceuil4 = {
    title: '',
    content: '',
    variables:''
  }
  acceuil5 = {
    title: '',
    content: '',
    variables:''
  }
  acceuil21 = {
    title: '',
    content: '',
    variables:''
  }
  acceuil22 = {
    title: '',
    content: '',
    variables:''
  }
  acceuil23 = {
    title: '',
    content: '',
    variables:''
  }
  ports = [];
  acceuilVideo = "https://www.w3schools.com/howto/rain.mp4";
  filterActivities = [];
  mvmnvArrivees;
  mvmnvdeparts;
  dataActualite;
  slick = null;
  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.currentLg = lg
      lg.code == "ar" ? this.isArab=true :this.isArab=false;
      this.getStatistiques();
      this.service.getPortnet().subscribe(datas => {
        this.regions =  [];
        datas['value'].forEach(element => {
          if (element.GInfo !== null && element.GInfo !== undefined && element.GInfo !== '') {
            const obj = {
              gInfo: this.returnJson(element.GInfo),
              circleInfo: this.returnJson(element.CircleInfo),
              pathInfo: this.returnJson(element.PathInfo),
              codeActivitePortuaire: element.CodeActivitePortuaire,
              CodePort: element.CodePort,
              textInfo: this.returnJson(element.TextInfo),
              CodeRegion: element.CodeRegion,
              pathPort: element.CodePort.toLowerCase().split('ports.port')[1]
            }
            if(this.regions.indexOf(element.CodeRegion) === -1) {
              this.regions.push(element.CodeRegion);
            }
            this.ports.push(obj);
          }
        });
      });
      this.service.getDescription('Accueil1', lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
          this.acceuil1.title = datas['value'][0].Title;
          this.acceuil1.content = datas['value'][0].Contenu;
        }
      });
      this.service.getDescription('Accueil2', lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
          this.acceuil2.title = datas['value'][0].Title;
          this.acceuil2.content = datas['value'][0].Contenu;
        }
      });
      this.service.getDescription('Accueil3', lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
          this.acceuil3.title = datas['value'][0].Title;
          this.acceuil3.content = datas['value'][0].Contenu;
          this.acceuil3.variables = datas['value'][0].Variables;
        }
      });
      this.service.getDescription('Accueil4', lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
          this.acceuil4.title = datas['value'][0].Title;
          this.acceuil4.content = datas['value'][0].Contenu;
          this.acceuil4.variables = datas['value'][0].Variables;
        }
      });
      this.service.getDescription('Accueil5', lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
          this.acceuil5.title = datas['value'][0].Title;
          this.acceuil5.content = datas['value'][0].Contenu;
          this.acceuil5.variables = datas['value'][0].Variables;
        }
      });
      this.service.getDescription('Accueil21', lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
          this.acceuil21.title = datas['value'][0].Title;
          this.acceuil21.content = datas['value'][0].Contenu;
          this.acceuil21.variables = datas['value'][0].Variables;
        }
      });
      this.service.getDescription('Accueil22', lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
          this.acceuil22.title = datas['value'][0].Title;
          this.acceuil22.content = datas['value'][0].Contenu;
          this.acceuil22.variables = datas['value'][0].Variables;
        }
      });
      this.service.getDescription('Accueil23', lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
          this.acceuil23.title = datas['value'][0].Title;
          this.acceuil23.content = datas['value'][0].Contenu;
          this.acceuil23.variables = datas['value'][0].Variables;
        }
      });
      this.dataActualite=[];
      this.offres = [];
      if (this.slick != null) {
        this.slick.slick('destroy');
      }
      if (this.slick1 != null) {
        this.slick1.slick('destroy');
      }
      this.publicationService.getActualite(lg.url, true).subscribe(data=>{
        this.dataActualite = data["value"];
        setTimeout(() => this.sliderBanner(lg), 10);
      })
      this.publicationService.getOffres(lg.url, true).subscribe(requestTwo => {
        this.offres = requestTwo["value"];
        setTimeout(() => this.slickContent(lg), 100);
      });
    });
    this.service.getMvmNaviresDeparts().subscribe(data => {
      this.mvmnvdeparts = data;
    })
    this.service.getMvmNaviresArrivees().subscribe(data => {
      this.mvmnvArrivees = data;
    })
  }
  returnJson(obj) {
    if (obj === null || obj === undefined || obj === '') {
      return null;
    } else {
      try {
        return JSON.parse(obj);
      } catch {
        return null
      }
    }
  }
  filterPortByActivities(filter) {
    if (this.filterActivities.indexOf(filter) === -1) {
      this.filterActivities.push(filter);
    } else {
      _.remove(this.filterActivities, function (currentObject) {
        return currentObject === filter;
      });
    }
  }
  filterPortByRegion(filter) {
    if (this.filterRegions.indexOf(filter) === -1) {
      this.filterRegions.push(filter);
    } else {
      _.remove(this.filterRegions, function (currentObject) {
        return currentObject === filter;
      });
    }
  }
  resetContentLanguage() {
    this.acceuil1 = {
      title: '',
      content: '',
      variables:''
    }
    this.acceuil2 = {
      title: '',
      content: ''
    }
    this.acceuil3 = {
      title: '',
      content: '',
      variables:''
    }
    this.acceuil4 = {
      title: '',
      content: '',
      variables:''
    }
    this.acceuil5 = {
      title: '',
      content: '',
      variables:''
    }
  }
  convertTime(t) {
    return new Date(+t.split("(")[1].split(")")[0].split("+")[0]).toLocaleTimeString().substring(0, 5)
  }

  slickContent(lg) {
    if (lg.code != "ar") {
      this.slick = $('.slickContent').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
    else {
      this.slick = $('.slickContent').slick({
        rtl: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  }
  getLine(s: string) {
    return s?.substr(0, 240) + "...";
  }
  converteDate(d: string) {
    return this.global.formattedDate(d);
  }
  navigateTo(port) {
    this.router.navigate(['/services/port', port.pathPort]);
  }
  sliderBanner(lg) {
    if (lg.code != "ar") {
      $(".slider").not('.slick-initialized').slick()
      this.slick1=$('.slider-banner').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        fade: true,
        cssEase: 'linear'
      });
    }
    else{
      $(".slider").not('.slick-initialized').slick()
      this.slick1=$('.slider-banner').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        rtl: true,
        fade: true,
        cssEase: 'linear'
      });
    };
  }
  substring(str:string){
    return str.charAt(0).toUpperCase()+str.toLowerCase().substring(1,120)+"...";
  }
  modal(url:string){
    $("#video").attr('src',url + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0" );
    $("#myModal").modal("show");
    $('#myModal').on('hide.bs.modal', (e)=>{
      $("#video").attr('src',""); 
  }) 
  }
  getStatistiques() {
    forkJoin(
      [
        this.StatistiqueService.getRapportDeSyntheseLastOne(this.global._basedUrl + this.global._FrUrl),
        this.StatistiqueService.getStatistiqueAnnuelLastOne(this.global._basedUrl + this.global._FrUrl),
        this.StatistiqueService.getStatistiqueMensuelleLastOne(this.global._basedUrl + this.global._FrUrl),
      ]
    ).subscribe(datas => {
    
     this.lastSynthese = datas[0]['value'] !== null && datas[0]['value'] !== undefined ? datas[0]['value'][0] : null
     this.lastAnnualReport = datas[1]['value'] !== null && datas[1]['value'] !== undefined ? datas[1]['value'][0] : null
     if(datas[2]['value'] !== null  && datas[2]['value'] !== undefined  &&  datas[2]['value'].length > 0 ) {
      const lastYear = datas[2]['value'][0].Annee;
      let lastMonth = 0;
      let index = 0;
      let indexElmnt = 0;
      datas[2]['value'].forEach(element => {
        if(element.Annee === lastYear) {
          if(element.Mois !== null && element.Mois !== undefined && (+element.Mois) > lastMonth) {
            indexElmnt = index;
          }
        }
        index ++;
      });
      this.lastMonthReport = datas[2]['value'][indexElmnt];
 

     } else {
       this.lastMonthReport = null;
     }
   
    })
  }
  downloadTarget(target) {

    if(target !== null && target.File !== undefined )
    {

      const  targetLink =  this.global._baseUrlStatique + target.File.ServerRelativeUrl;
      var redirect = window.open(targetLink,'_blank');
      redirect.location;
    }
  }
  ReturnPortName(portCode){
    return 'portName.' + portCode.split('.')[1];
  }
  changeRegion() {
    this.selectedPort = null;
    this.selectedActivite = [];
    this.selectedPortPath = null;
  }
  getPortActivity(item) {
    
    if (item !== null) {
      this.ports.forEach(element => {
        if(element.CodePort === item) {
          this.selectedActivite =  element.codeActivitePortuaire;
          this.selectedPortPath = element;
        }
      });
    } else {
      this.selectedActivite =  [];
    }
    
  }
}
